export const SET_SEARCH = 'SET_INFROMATIONS_SEARCH';
export const SET_FILTER_VISIBLE = 'SET_INFORMATIONS_FILTER_VISIBLE';
export const SET_PERIOD = 'SET_INFORMATIONS_PERIOD';
export const SET_TYPES = 'SET_INFORMATIONS_TYPES';
export const SET_COMPANIES = 'SET_INFORMATIONS_COMPANIES';
export const SET_STREETS = 'SET_INFORMATIONS_STREETS';
export const SET_HOUSES = 'SET_INFORMATIONS_HOUSES';
export const SET_ADDRESSES = 'SET_INFORMATIONS_ADDRESSES';
export const SET_ONLY_ACTIVE = 'SET_INFORMATIONS_ONLY_ACTIVE';
export const SET_FILTER_STATE = 'SET_INFORMATIONS_FILTER_STATE';
export const RESET_FILTER_STATE = 'RESET_INFORMATIONS_FILTER_STATE';
export const SET_SELECTED_INFO = 'SET_SELECTED_INFO';
export const SET_EDITOR_STATE = 'SET_INFORMATIONS_EDITOR_STATE';
export const SET_EDITOR_LINK_MODAL_DATA =
  'SET_INFORMATIONS_EDITOR_LINK_MODAL_DATA';
export const SET_EDITOR_PHONE_MODAL_DATA =
  'SET_INFORMATIONS_EDITOR_PHONE_MODAL_DATA';